module.exports = __webpack_public_path__ + "static/media/star_right.b8295d3b.svg";